import { NavLink } from "react-router-dom";
import { Clapperboard } from "lucide-react";
import { NAV_ITEMS } from "@/shared/nav";
import { cn } from "@/shared/lib/cn";

/** 桌面侧栏导航 */
export function Sidebar() {
  return (
    <aside className="hidden w-[220px] shrink-0 flex-col border-r border-border bg-bg-elevated md:flex">
      <div className="flex h-14 items-center gap-2 border-b border-border px-4">
        <Clapperboard className="size-5 text-brand" strokeWidth={1.75} />
        <div className="leading-tight">
          <div className="text-[13px] font-semibold tracking-tight text-fg">
            Cinema Console
          </div>
          <div className="text-[11px] text-fg-subtle">MoviePilot</div>
        </div>
      </div>
      <nav className="flex flex-1 flex-col gap-0.5 p-2">
        {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "flex h-9 items-center gap-2.5 rounded-[var(--radius-sm)] px-2.5 text-[13px] transition-colors duration-[var(--dur)]",
                isActive
                  ? "bg-brand-muted text-brand"
                  : "text-fg-muted hover:bg-bg-hover hover:text-fg",
              )
            }
          >
            <Icon className="size-4 shrink-0" strokeWidth={1.75} />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
